/*
 * @Description:
 * @LastEditTime: 2024-02-02 10:44:10
 * @LastEditors: 何俊峰
 * @Author: 何俊峰
 * @Date: 2024-02-01 17:01:32
 */
import defaultTxt from './txt.js'
export default {
  // base_url: 'http://adminks.yiosi.cn/api',
  // base_url: 'http://community-admin-test.yi-types.top/api',
  // base_url: 'http://community-admin.yi-types.top/api',
  base_url: '/api',
  hasShow: false,
  txt: defaultTxt
}